import { BaseRequestModel } from "./BaseModel/BaseRequestModel";

export class ActiveTendersSearchRequestModel extends BaseRequestModel{
    tenderClosingDate?:Date
    PPRA_RefNo?:string
    city:string
}